// src/utils/notifications/notificationApi.js
// Thin client for puminet5api's FCM device endpoints (`androidPersonDevice` table).
// Both endpoints derive `personId` from the JWT — do not send it in the body.

import { API_URL } from "src/utils/apiUrl";
import { jsonOrThrow, authHeaders } from "src/utils/apiFetch";

/**
 * Register the current device's FCM token against the JWT-identified person.
 * `deviceInfo.source = "betonijerry"` is the isolation marker that lets the
 * backend distinguish betonijerry-issued tokens from puminet4-issued ones, even
 * though both apps share the same `androidPersonDevice` table.
 */
export async function registerDevice({ fcmToken, token }) {
    const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
    const deviceInfo = {
        source: "betonijerry",
        isMobile: /android|iphone|ipad|ipod|mobile/i.test(ua),
        userAgent: ua,
        platform: (typeof navigator !== "undefined" && navigator.platform) || "",
        language: (typeof navigator !== "undefined" && navigator.language) || "",
    };
    const res = await fetch(`${API_URL}/api/android-notifications/register`, {
        method: "POST",
        headers: { ...authHeaders(token), "Content-Type": "application/json" },
        body: JSON.stringify({ fcmToken, deviceInfo }),
    });
    return jsonOrThrow(res);
}

/**
 * Unregister a specific FCM token for the JWT-identified person. The backend
 * scopes the DELETE to (personId, fcmToken) — other devices remain registered.
 */
export async function unregisterDevice({ fcmToken, token }) {
    const res = await fetch(`${API_URL}/api/android-notifications/device`, {
        method: "DELETE",
        headers: { ...authHeaders(token), "Content-Type": "application/json" },
        body: JSON.stringify({ fcmToken }),
    });
    return jsonOrThrow(res);
}
